import { useState, useEffect } from "react";
import PdfOrdemPagamento from "../../../shared/components/PdfGenerator/PdfOrdemPagamento/PdfOrdemPagamento";
import { DataGrid } from "@mui/x-data-grid";
import dataGridData from "./components/datagridData";
import moment from "moment";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import toast from "react-hot-toast";
import { generateExcelFile } from "../../../shared/components/excelUtils/exportExcel";
//Modais
import ModalSaida from "./components/modalSaida/ModalSaida";
import ModalVerSaida from "./components/modalSaida/ModalVerSaida";
import ModalPagarSaida from "./components/modalSaida/ModalPagarSaida";
import ModalEditarSaida from "./components/modalSaida/ModalEditarSaida";
import ModalCorrigirCaixa, {
  podeCorrigirCaixa,
} from "../../../shared/components/modalCorrigirCaixa/ModalCorrigirCaixa";
//ICONS
import ErrorIcon from "@mui/icons-material/Error";
import CallMadeIcon from "@mui/icons-material/CallMade";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import EditIcon from "@mui/icons-material/Edit";

//Context
import { useLoading } from "../../../shared/context/LoadingContext";
import {
  podeAlterarRegisto,
  motivoBloqueioUnidade,
  paramsUnidadeDados,
} from "../../../shared/util/unidadeRegisto";
import SeletorUnidadeDados, {
  TODAS_UNIDADES,
} from "../../../shared/components/badgeUnidade/SeletorUnidadeDados";
import { dadosImpressao } from "../../../shared/util/dadosImpressao";

//MUI
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";
import FiltrosSaida from "./components/filtrosSaida/FiltrosSaida";
import BadgeUnidade from "../../../shared/components/badgeUnidade/BadgeUnidade";
import SeloSoConsulta from "../../../shared/components/badgeUnidade/SeloSoConsulta";

function Saidas({ clinicaId, auth, clinicaData }) {
  const { startLoading, stopLoading } = useLoading();

  const { sendRequest } = useHttpClient();
  const [rows, setRows] = useState([]);
  const [saidas, setSaidas] = useState();
  const [saidasParaTextSearch, setSaidasParaTextSearch] = useState();
  const [saidasAbsolut, setSaidasAbsolut] = useState();
  const [financialData, setFinancialData] = useState({});
  const [openModal, setOpenModal] = useState("");
  /* Id da saída a editar (caixa, descrição e observação). Vive fora do
     `openModal` porque abre a partir do menu da linha, e não de outra janela. */
  const [corrigirCaixa, setCorrigirCaixa] = useState(null);
  const [saidaId, setSaidaId] = useState();
  const [modalData, setModalData] = useState({});
  const [filtrosAplicados, setFiltrosAplicados] = useState([]);
  const [filtroCaixa, setFiltroCaixa] = useState();
  const [filtroCategoria, setFiltroCategoria] = useState();
  const [filtroMetodoPagamento, setFiltroMetodoPagamento] = useState();
  const [filtroTextoSearch, setFiltroTextoSearch] = useState("");

  const [ordemPagamentoData, setOrdemPagamentoData] = useState(null);
  // A ordem de pagamento sai com a morada da unidade onde a despesa foi
  // registada, não com a da sede — é lá que o dinheiro sai.
  const [ordemPagamentoUnidade, setOrdemPagamentoUnidade] = useState(null);
  const [showPdf, setShowPdf] = useState(false);

  /* De que unidade são os dados deste ecrã. Arranca na da sessão: as despesas
     pagam-se onde foram registadas, e quem abre este ecrã quer as suas.
     Não é um filtro — muda o PEDIDO. Ver `SeletorUnidadeDados`. */
  const [unidadeDados, setUnidadeDados] = useState(
    () => auth.estabelecimento?._id ?? null,
  );

  /* O período em curso. As datas vivem no componente de filtros e não subiam
     até aqui; sem isto, trocar de unidade voltava sempre ao dia de hoje. */
  const [periodoAtual, setPeriodoAtual] = useState(() => ({
    inicio: new Date().toISOString(),
    fim: new Date().toISOString(),
    filtrosDatas: undefined,
  }));

  const fetchSaida = async (
    startDate,
    endDate,
    filtrosDatas = {
      dataPagamento: true,
      dataLimitePagamento: true,
      dataCriacao: true,
    },
    unidade = unidadeDados,
  ) => {
    let responseSaidas = { saidas: [] };
    startLoading();
    setPeriodoAtual({ inicio: startDate, fim: endDate, filtrosDatas });
    try {
      const formData = new FormData();
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      formData.append("filtrosDatas", JSON.stringify(filtrosDatas));

      /* A unidade vai no PEDIDO, não é filtrada depois de chegar. Só se
         acrescenta o que `paramsUnidadeDados` devolver — em FormData tudo
         vira string, e um "false" seria tão verdadeiro como um "true". */
      for (const [chave, val] of Object.entries(
        paramsUnidadeDados(unidade, auth),
      )) {
        formData.append(chave, String(val));
      }

      if (auth.perm.includes("r-des")) {
        responseSaidas = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/clinica/daterange/${clinicaId}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      }
      setSaidas(responseSaidas.despesas);
      setSaidasAbsolut(responseSaidas.despesas);
      setSaidasParaTextSearch(responseSaidas.despesas);

      handleFiltrar(responseSaidas.despesas, [], null, null, null, "", {
        dataInicial: moment(startDate).format("DD/MM/YYYY"),
        dataFinal: moment(endDate).format("DD/MM/YYYY"),
      });
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    fetchSaida(new Date().toISOString(), new Date().toISOString());
  }, []);

  /* Trocar de unidade é um pedido novo, não um recorte do que já veio — e
     mantém o período que estava à vista. */
  const trocarUnidade = (nova) => {
    setUnidadeDados(nova);
    fetchSaida(
      periodoAtual.inicio,
      periodoAtual.fim,
      periodoAtual.filtrosDatas,
      nova,
    );
  };

  /* No consolidado, cada linha diz de que unidade é. Numa unidade só, não —
     seria a mesma pastilha repetida em todas as linhas. */
  const verTodasUnidades = unidadeDados === TODAS_UNIDADES;

  useEffect(() => {
    let dataParaDataGrid = [];
    let aPagar = 0;
    let totalSaidas = 0;

    if (saidas && saidas.length > 0) {
      saidas.forEach((saida) => {
        if (saida.despesaPaga) totalSaidas += saida.valor;
        else aPagar += saida.valor;
        dataParaDataGrid.push({
          tipo: "saida",
          id: saida.id,
          dataCriacao: saida.created_at,
          dataLimitePagamento: saida.dataLimitePagamento,
          dataPagamento: saida.dataPagamento,
          valor: saida.valor,
          metodoPagamento: saida.metodoPagamento,
          banco: saida.banco,
          nrContaCliente: saida.nrContaCliente,
          nrCheque: saida.nrCheque,
          dataCheque: saida.dataCheque,
          despesaPaga: saida.despesaPaga,
          descricao: saida.descricao,
          // Unidade da despesa: a do proprio registo, ou a da caixa de
          // onde o dinheiro saiu (registos anteriores ao carimbo).
          estabelecimento:
            saida.estabelecimento || saida.caixa?.estabelecimento,
          comprovativo: saida.comprovativo,
          nrOrdemPagamento: saida.nrOrdemPagamento || "",
          estado: saida.despesaPaga
            ? "Pago"
            : moment()
                  .startOf("day")
                  .isAfter(moment(saida.dataLimitePagamento).startOf("day"))
              ? "Em atraso"
              : "",
          categoria: saida.categoria?.categoria,
          caixa: saida.caixa?.caixa,
          fornecedor: saida.fornecedor,
          cliente: saida.cliente,
          funcionario: saida.funcionario,
          funcionarioUser: saida.funcionarioUser,
        });
      });
    }
    dataParaDataGrid = dataParaDataGrid.sort(
      (a, b) =>
        new Date(a.dataPagamento ? a.dataPagamento : a.dataLimitePagamento) -
        new Date(b.dataPagamento ? b.dataPagamento : b.dataLimitePagamento),
    );

    setFinancialData({
      totalPago: totalSaidas.toLocaleString("pt-BR"),
      totalPorPagar: aPagar.toLocaleString("pt-BR"),
    });

    setRows(dataGridData(dataParaDataGrid));
  }, [saidas]);

  const updateSaidas = (saidaAdicionada, action) => {
    if (!action) {
      //Inserir
      const tempSaidas = [...saidas];
      const tempSaidasAbsolut = [...saidasAbsolut];
      const tempSaidasParaTextSearch = [...saidasParaTextSearch];

      tempSaidas.push(saidaAdicionada);
      tempSaidasAbsolut.push(saidaAdicionada);
      tempSaidasParaTextSearch.push(saidaAdicionada);

      setSaidasAbsolut([...tempSaidasAbsolut]);
      setSaidasParaTextSearch([...tempSaidasParaTextSearch]);
      setSaidas([...tempSaidas]);
    } else {
      //Atualizar
      //Se for a atualizacao de uma saida, verificamos se ela pertence ao alcance de datas da mesma forma.
      //Se sim mantemo-la, se não, removemo-la
      let tempSaidasAbsolut;
      let tempSaidas;
      let tempSaidasParaTextSearch;

      tempSaidasAbsolut = saidasAbsolut.map((e) => {
        if (e._id === saidaAdicionada._id) {
          return saidaAdicionada;
        } else {
          return e;
        }
      });
      tempSaidasParaTextSearch = saidasParaTextSearch.map((e) => {
        if (e._id === saidaAdicionada._id) {
          return saidaAdicionada;
        } else {
          return e;
        }
      });
      tempSaidas = saidas.map((e) => {
        if (e._id === saidaAdicionada._id) {
          return saidaAdicionada;
        } else {
          return e;
        }
      });

      setSaidas([...tempSaidas]);
      setSaidasAbsolut([...tempSaidasAbsolut]);
      setSaidasParaTextSearch([...tempSaidasParaTextSearch]);
    }
  };

  const handleCloseModal = () => {
    setOpenModal("");
  };

  const handleOpenModalPagarSaida = (id) => {
    setOpenModal("pagarSaida");
    setModalData(saidas.filter((saida) => saida.id === id)[0]);
  };

  const handleVerSaida = (id) => {
    const saidaFiltrada = saidas.filter((desp) => desp.id === id)[0];
    setModalData(saidaFiltrada);
    setOpenModal("verSaida");
  };

  const handleCancelarPagamentoSaida = async (id) => {
    startLoading();

    try {
      //SERA QUE NO TEM QUE REMOVE COMPROVATIVO????
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      const result = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/anularPagamento/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );
      if (result.success) {
        const tempSaidas = [...saidas];
        const saidaFiltrada = tempSaidas.find((saida) => saida.id === id);
        delete saidaFiltrada.metodoPagamento;
        delete saidaFiltrada.pagaPor;
        delete saidaFiltrada.dataPagamento;
        saidaFiltrada.despesaPaga = false;
        saidaFiltrada.pagamentoCanceladoPor = {
          _id: auth.userId,
          name: auth.nome,
        };

        updateSaidas(saidaFiltrada, "atualizar");

        toast.success("Pagamento revertido com sucesso!");
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const editarSaidaHandler = (id) => {
    setSaidaId(id);
    setOpenModal("editarSaida");
  };

  const apagarSaidaHandler = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/eliminar/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      const tempSaidas = [...saidas];
      const tempSaidasAbsolut = [...saidasAbsolut];
      const tempSaidasParaTextSearch = [...saidasParaTextSearch];

      const indexSaida = tempSaidas.findIndex((saida) => saida.id === id);
      const indexSaidaAbsolut = tempSaidas.findIndex(
        (saida) => saida.id === id,
      );
      const indexSaidaParaTextSearch = tempSaidasParaTextSearch.findIndex(
        (saida) => saida.id === id,
      );

      tempSaidas.splice(indexSaida, 1);
      tempSaidasAbsolut.splice(indexSaidaAbsolut, 1);
      tempSaidasParaTextSearch.splice(indexSaidaParaTextSearch, 1);

      setSaidas([...tempSaidas]);
      setSaidasAbsolut([...tempSaidasAbsolut]);
      setSaidasParaTextSearch([...tempSaidasParaTextSearch]);

      toast.success("Saída eliminada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleFiltrar = (
    newSaidas,
    filtros,
    filtroCai,
    filtroCat,
    filtroMet,
    textoSearch,
    data,
  ) => {
    if (newSaidas) {
      setSaidas([...newSaidas]);
    }

    if (data === "modalFiltros") {
      setSaidasParaTextSearch([...newSaidas]);
    }

    if (data !== "textSearch") {
      setFiltrosAplicados(filtros);
      setFiltroCaixa(filtroCai);
      setFiltroCategoria(filtroCat);
      setFiltroMetodoPagamento(filtroMet);
    }
    setFiltroTextoSearch(textoSearch);
  };

  const handleExportar = () => {
    const sheetData = rows.map((r) => {
      const baseData = {
        descricao: r.descricao
          ? r.descricao
          : `${r.nome}${r.nrParcela ? " - Parcela " + r.nrParcela : ""}`,
        cliente: r.cliente,
        valor: r.valor,
        tipo: r.tipo,
        estado: r.estado,
        data_Pagamento: r.dataPagamento
          ? moment(r.dataPagamento).format("DD/MM/YYYY")
          : "-",
        dataLimitePagamento: r.dataLimitePagamento
          ? moment(r.dataLimitePagamento).format("DD/MM/YYYY")
          : "-",
        metodoPagamento: r.metodoPagamento ? r.metodoPagamento : "-",
        categoria: r.categoria ? r.categoria : "-",
        caixa: r.caixa ? r.caixa : "-",
      };

      // Adicionar campos de cheque se o método de pagamento for cheque
      if (
        r.metodoPagamento === "Cheque" ||
        r.metodoPagamento === "Cheque Visado"
      ) {
        baseData.banco = r.banco || "-";
        baseData.nrContaCliente = r.nrContaCliente || "-";
        baseData.nrCheque = r.nrCheque || "-";
        baseData.dataCheque = r.dataCheque
          ? moment(r.dataCheque).format("DD/MM/YYYY")
          : "-";
      }

      return baseData;
    });

    generateExcelFile(
      `HistoricoSaidas ${moment().format("DD/MM/YYYY")}.xlsx`,
      "Saidas",
      sheetData,
    );
  };

  const actionColumn = [
    {
      field: "inOrOut",
      headerName: "",
      width: 30,
      renderCell: (params) => {
        return (
          <CallMadeIcon className="financeiro__container__cabecalho__totais--icon_div--despesa" />
        );
      },
    },
    {
      field: "dataCriacao",
      headerName: "Dt Criação",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            <div className="receita__DataCriacao">
              {moment(params.row.dataCriacao).format("DD/MM/YYYY")}
            </div>
          </div>
        );
      },
    },
    {
      field: "dataLimitePagamento",
      headerName: "Dt Vencimento",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            <div
              className={
                params.row.despesaPaga && params.row.dataLimitePagamento
                  ? "spanCellPago"
                  : !params.row.despesaPaga &&
                      moment().isAfter(
                        moment(params.row.dataLimitePagamento),
                        "day",
                      )
                    ? "spanCellAtraso"
                    : ""
              }
            >
              {params.row.despesaPaga && params.row.dataLimitePagamento
                ? moment(params.row.dataLimitePagamento).format("DD/MM/YYYY")
                : moment(params.row.dataLimitePagamento).format("DD/MM/YYYY")}
            </div>
          </div>
        );
      },
    },
    {
      field: "data",
      headerName: "Dt Pagamento",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            <span
              className={
                params.row.despesaPaga && params.row.dataPagamento
                  ? "spanCellPago"
                  : !params.row.despesaPaga &&
                      moment(params.row.dataLimitePagamento) < moment()
                    ? "spanCellAtraso"
                    : ""
              }
            >
              {params.row.despesaPaga
                ? moment(params.row.dataPagamento).format("DD/MM/YYYY")
                : "N/A"}
            </span>
          </div>
        );
      },
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 6,
      renderCell: (params) => {
        return (
          <>
            <div
              className={
                params.row.despesaPaga && params.row.dataPagamento
                  ? "spanCellPago"
                  : !params.row.despesaPaga &&
                      moment(params.row.dataLimitePagamento) < moment()
                    ? "spanCellAtraso"
                    : ""
              }
            >
              {/* Só no consolidado. Quando se está a ver uma unidade, todas as
                  linhas são dela e a pastilha seria ruído repetido. */}
              {verTodasUnidades && (
                <BadgeUnidade
                  estabelecimento={params.row.estabelecimento}
                  prefixo="Registada em"
                />
              )}{" "}
              {params.row.descricao}
              {/* Ordem de pagamento já emitida. Sem isto não havia como saber
                  quais as saídas que já a têm sem abrir o menu de ações uma a
                  uma — e reimprimir devolve o mesmo número, mas «Criar» gera um
                  novo, por isso a distinção importa. */}
              {params.row.nrOrdemPagamento && (
                <Tooltip
                  title={`Ordem de pagamento ${params.row.nrOrdemPagamento}`}
                >
                  <ArticleOutlinedIcon className="iconeOrdemPagamento" />
                </Tooltip>
              )}
              <Tooltip title="Ver Saída">
                <IconButton onClick={handleVerSaida.bind(null, params.row.id)}>
                  <ErrorIcon className="muiIconVerOrcamento" />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
    },
    {
      field: "estado",
      headerName: "Pagamento",
      flex: 2,
      renderCell: (params) => {
        return (
          <div className="cellDebitoEstado">
            <span
              className={`debitos__container__estado ${
                params.row.estado === "Em atraso"
                  ? "debitos__container__estado--atraso"
                  : params.row.estado === "Pago"
                    ? "debitos__container__estado--pago"
                    : ""
              }`}
            >
              {params.row.metodoPagamento
                ? params.row.metodoPagamento
                : params.row.estado}
            </span>
          </div>
        );
      },
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      renderCell: (params) => {
        return (
          <span
            className={
              params.row.despesaPaga && params.row.dataPagamento
                ? "spanCellPago"
                : !params.row.despesaPaga &&
                    moment(params.row.dataLimitePagamento) < moment()
                  ? "spanCellAtraso"
                  : ""
            }
            style={{ marginLeft: "auto" }}
          >
            {params.row.valor}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Ações",
      flex: 1,
      renderCell: (params) => {
        // Uma saída de outra unidade é só de consulta: paga-se, edita-se e
        // elimina-se onde foi registada, para o dinheiro não sair da caixa
        // errada. O servidor recusa à mesma; isto evita a tentativa.
        const podeAlterar = podeAlterarRegisto(
          params.row.estabelecimento,
          auth,
        );

        /* Saída de outra unidade: a coluna de ações fica VAZIA.
         *
         * Nem «Pagar», nem menu de três pontos. Tudo o que o menu oferece —
         * pagar, editar, eliminar, anular pagamento, ordem de pagamento — é
         * indisponível fora da unidade onde a despesa foi registada, e um menu
         * inteiro desativado é ruído. A pastilha na coluna do nome já diz de
         * quem é a linha.
         *
         * Sai ANTES de montar o `content`, para não construir um menu que não
         * vai ser mostrado. */
        if (!podeAlterar) return null;

        const avisoUnidade = !podeAlterar && (
          <div
            className="popOverMenu--option"
            style={{ cursor: "default" }}
          >
            <SeloSoConsulta estabelecimento={params.row.estabelecimento} />
          </div>
        );

        /* As opções bloqueadas ficam ACINZENTADAS, não desaparecem — o mesmo
           que nas Receitas. Quem procura "cancelar pagamento" e não o encontra
           pensa que é avaria ou que perdeu a permissão; acinzentada, sabe que
           existe e porque não pode. A razão está no `title`. */
        const motivoUnidade = podeAlterar
          ? undefined
          : motivoBloqueioUnidade(params.row.estabelecimento);

        const opcaoBloqueada = (texto, icone) => (
          <div
            className="popOverMenu--option popOverMenu--option--desativada"
            title={motivoUnidade}
          >
            <span>{texto}</span>
            {icone}
          </div>
        );

        /* Criar a ordem CONSOME um número da sequência da outra unidade, por
           isso obedece à unidade. Reimprimir uma já criada não consome nada e
           fica livre — é só leitura. */
        const criaOrdem = !params.row.nrOrdemPagamento;

        let content;
        if (params.row.despesaPaga) {
          content = (
            <div className="dots__menu__popup">
              {avisoUnidade}
              {/* Saidas Pagas */}
              {/* Uma saída paga não se edita pelo caminho normal, mas a caixa,
                  a descrição e a observação sim — ver `ModalCorrigirCaixa`. */}
              {podeCorrigirCaixa(auth) &&
                (podeAlterar ? (
                  <div
                    className="popOverMenu--option"
                    onClick={() => setCorrigirCaixa(params.row.id)}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                ) : (
                  opcaoBloqueada(
                    "Editar",
                    <EditIcon className="popOverMenu--option__icon" />,
                  )
                ))}
              {auth.perm.includes("r-des") &&
                (criaOrdem && !podeAlterar ? (
                  opcaoBloqueada(
                    "Criar Ordem de Pagamento",
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />,
                  )
                ) : (
                  <div
                    className="popOverMenu--option"
                    onClick={() => handleGerarOrdemPagamento(params.row)}
                  >
                    <span>
                      {criaOrdem
                        ? "Criar Ordem de Pagamento"
                        : "Gerar Pdf Ordem de Pagamento"}
                    </span>
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                  </div>
                ))}
              {auth.perm.includes("u-des") &&
                (podeAlterar ? (
                  <Popconfirm
                    title="Cancelar Pagamento"
                    description={`Pretende cancelar o pagamento da saída ${params.row.descricao}?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleCancelarPagamentoSaida.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Cancelar pagamento</span>
                      <HighlightOffIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    "Cancelar pagamento",
                    <HighlightOffIcon className="popOverMenu--option__icon" />,
                  )
                ))}

              {params.row.comprovativo &&
                params.row.comprovativo.ficheiro &&
                auth.perm.includes("r-des") && (
                  <a
                    href={`${process.env.REACT_APP_BACKEND_LINK}/${params.row.comprovativo.ficheiro}`}
                    download={
                      params.row.comprovativo.descricao || "comprovativo"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="popOverMenu--option">
                      <span>Baixar Comprovativo</span>
                      <DownloadIcon className="popOverMenu--option__icon" />
                    </div>
                  </a>
                )}
            </div>
          );
        } else if (!params.row.despesaPaga) {
          content = (
            <div className="dots__menu__popup">
              {avisoUnidade}
              {/* Saidas nao pagas */}
              {auth.perm.includes("u-des") &&
                (podeAlterar ? (
                  <div
                    className="popOverMenu--option"
                    onClick={editarSaidaHandler.bind(null, params.row.id)}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                ) : (
                  opcaoBloqueada(
                    "Editar",
                    <EditIcon className="popOverMenu--option__icon" />,
                  )
                ))}
              {auth.perm.includes("r-des") &&
                (criaOrdem && !podeAlterar ? (
                  opcaoBloqueada(
                    "Criar Ordem de Pagamento",
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />,
                  )
                ) : (
                  <div
                    className="popOverMenu--option"
                    onClick={() => handleGerarOrdemPagamento(params.row)}
                  >
                    <span>
                      {criaOrdem
                        ? "Criar Ordem de Pagamento"
                        : "Gerar Pdf Ordem de Pagamento"}
                    </span>
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                  </div>
                ))}

              {params.row.comprovativo &&
                params.row.comprovativo.ficheiro &&
                auth.perm.includes("r-des") && (
                  <a
                    href={`${process.env.REACT_APP_BACKEND_LINK}/${params.row.comprovativo.ficheiro}`}
                    download
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="popOverMenu--option">
                      <span>Baixar Comprovativo</span>
                      <DownloadIcon className="popOverMenu--option__icon" />
                    </div>
                  </a>
                )}
              {auth.perm.includes("d-des") &&
                (podeAlterar ? (
                  <Popconfirm
                    title="Eliminar Saida"
                    description={`Pretende eliminar a saída de ${params.row.descricao}?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={apagarSaidaHandler.bind(null, params.row.id)}
                  >
                    <div className="popOverMenu--option">
                      <span>Eliminar</span>
                      <DeleteIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                ) : (
                  opcaoBloqueada(
                    "Eliminar",
                    <DeleteIcon className="popOverMenu--option__icon" />,
                  )
                ))}
            </div>
          );
        }

        return (
          <>
            {/* Saidas nao pagas */}
            {params.row.estado !== "Pago" &&
              auth.perm.includes("u-des") &&
              (podeAlterar ? (
                <span
                  className={`debitos__container__receber ${
                    params.row.estado === "Em atraso" &&
                    "debitos__container__receber--atraso"
                  }`}
                  onClick={handleOpenModalPagarSaida.bind(null, params.row.id)}
                >
                  Pagar
                </span>
              ) : (
                /* Paga-se onde a despesa foi registada, senão o dinheiro sai
                   da caixa errada. Visível e acinzentado, com a razão. */
                <span
                  className="debitos__container__receber debitos__container__receber--bloqueada"
                  title={motivoUnidade}
                >
                  Pagar
                </span>
              ))}

            {content && (
              <Popover content={content} trigger="click" placement="bottom">
                <div className="dots__menu">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </Popover>
            )}
          </>
        );
      },
    },
  ];

  const handleGerarOrdemPagamento = async (dadosSaida) => {
    let dadosParaPdf;
    let novaSaida;
    if (dadosSaida.nrOrdemPagamento) {
      dadosParaPdf = {
        numero: dadosSaida.nrOrdemPagamento,
        beneficiario:
          dadosSaida.fornecedor?.nome ||
          dadosSaida.cliente?.nome ||
          dadosSaida.funcionario?.nome ||
          dadosSaida.funcionarioUser?.name ||
          "",

        motivoPagamento: dadosSaida.descricao || "",
        banco: dadosSaida.banco || dadosSaida.caixa || "",
        chequeNumero: dadosSaida.nrCheque || "",
        valor: dadosSaida.valorOriginal,
        elaboradoPor: auth.nome || "",
      };
    } else {
      startLoading();
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/despesas/ordem-pagamento/${dadosSaida.id}`,
          "POST",
          JSON.stringify({
            clinicaId: clinicaId,
          }),
          {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          },
        );
        dadosParaPdf = response.ordemData;
        novaSaida = response.despesaData;
      } catch (err) {
        console.error("Erro ao gerar ordem de pagamento:", err);
        toast.error("Erro ao gerar ordem de pagamento");
      } finally {
        stopLoading();
      }
      updateSaidas(novaSaida, "atualizar");
    }

    // Mostrar o PDF
    setOrdemPagamentoData(dadosParaPdf);
    setOrdemPagamentoUnidade(dadosSaida.estabelecimento || null);
    setShowPdf(true);
  };

  const handleClosePdf = () => {
    setShowPdf(false);
    setOrdemPagamentoData(null);
  };

  return (
    <div className="financeiro__container caixa">
      {/* De que unidade são estes dados. Escolher aqui refaz o pedido. */}
      <SeletorUnidadeDados valor={unidadeDados} onChange={trocarUnidade} />

      <div className="financeiro__adicionarEFiltros">
        <FiltrosSaida
          saidasAbsolut={saidasAbsolut}
          saidasParaTextSearch={saidasParaTextSearch}
          handleFiltrar={handleFiltrar}
          handleExportar={handleExportar}
          filtrosAplicados={filtrosAplicados}
          filtroCaixa={filtroCaixa}
          filtroCategoria={filtroCategoria}
          filtroMetodoPagamento={filtroMetodoPagamento}
          filtroTextoSearch={filtroTextoSearch}
          clinicaId={clinicaId}
          auth={auth}
          fetchSaida={fetchSaida}
        />
        <div>
          {auth.perm.includes("c-des") && (
            <Button
              variant="contained"
              color="info"
              id="basic-button"
              onClick={(e) => setOpenModal("saida")}
            >
              + Adicionar Saída
            </Button>
          )}
        </div>
      </div>

      <div className="financeiro__container__cabecalho">
        <div className="financeiro__container__cabecalho__totais">
          <div className="financeiro__container__cabecalho__totais--por-receber">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--por-receber">
              <div className="financeiro__container__cabecalho__totais--icon_div">
                <span className="financeiro__container__cabecalho__totais--titulos">
                  Total Pago
                </span>
              </div>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--por-receber--valor_principal">
                  {financialData.totalPago}$00
                </span>
              </div>
            </div>
          </div>

          <div className="financeiro__container__cabecalho__totais--saldo">
            <div className="financeiro__container__cabecalho__totais__firstContainer financeiro__container__cabecalho__totais__firstContainer--saldo">
              <span className="financeiro__container__cabecalho__totais--titulos">
                Total a Pagar
              </span>
              <div className="financeiro__container__cabecalho__totais--texto">
                <span className="financeiro__container__cabecalho__totais--saldo--valor_principal">
                  {financialData.totalPorPagar}$00
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {rows && (
        <div style={{ height: 635, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={actionColumn}
            pageSize={10}
            rowsPerPageOptions={[10]}
          />
        </div>
      )}

      {openModal === "verSaida" && (
        <ModalVerSaida
          openModalVerSaida={openModal === "verSaida"}
          handleCloseModalVerSaida={handleCloseModal}
          dadosModalVerSaida={modalData}
        />
      )}

      {corrigirCaixa && (
        <ModalCorrigirCaixa
          open={!!corrigirCaixa}
          tipo="despesa"
          id={corrigirCaixa}
          onFechar={() => setCorrigirCaixa(null)}
          /* Depois de editar, a lista volta a pedir os dados: a caixa e a
             descrição aparecem na tabela e no fluxo de caixa. */
          onCorrigido={() =>
            fetchSaida(
              periodoAtual.inicio,
              periodoAtual.fim,
              periodoAtual.filtrosDatas,
            )
          }
        />
      )}

      {openModal === "pagarSaida" && (
        <ModalPagarSaida
          OpenModalPagarSaida={openModal === "pagarSaida"}
          handleCloseModalPagarSaida={handleCloseModal}
          dadosModalPagarSaida={modalData}
          sendRequest={sendRequest}
          updateSaidas={updateSaidas}
          auth={auth}
          clinicaId={clinicaId}
        />
      )}

      {openModal === "editarSaida" && (
        <ModalEditarSaida
          openModalEditarSaida={openModal === "editarSaida"}
          handleCloseModalEditarSaida={handleCloseModal}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
          saidaId={saidaId}
          updateSaidas={updateSaidas}
        />
      )}

      {openModal === "saida" && (
        <ModalSaida
          openModalSaida={openModal === "saida"}
          sendRequest={sendRequest}
          handleCloseModalSaida={handleCloseModal}
          clinicaId={clinicaId}
          auth={auth}
          updateSaidas={updateSaidas}
        />
      )}
      {showPdf && ordemPagamentoData && (
        <PdfOrdemPagamento
          ordemData={ordemPagamentoData}
          clinicaData={dadosImpressao(clinicaData, ordemPagamentoUnidade)}
          showPreviousPage={handleClosePdf}
          paperSize="A5"
        />
      )}
    </div>
  );
}

export default Saidas;
